import React from 'react'
import { ClientOnlyPortal } from './ClientOnlyPortal'
import { useRoot } from './RootContext'

type Props = {
  children?: React.ReactNode
}

/** Mounts a portal in a root provided by a DS user with a fallback to document.body */
export const RootPortal = ({ children }: Props) => {
  const root = useRoot()
  return <ClientOnlyPortal element={root}>{children}</ClientOnlyPortal>
}
